import { Modal, Text, Group, Button, Stack } from "@mantine/core";
import { IconAlertTriangle } from "@tabler/icons-react";

interface SessionTimeoutModalProps {
  opened: boolean;
  remainingSeconds: number;
  onExtend: () => void;
  onLogout: () => void;
}

function formatTime(seconds: number): string {
  const min = Math.floor(seconds / 60);
  const sec = seconds % 60;
  return `${min}:${sec.toString().padStart(2, "0")}`;
}

export default function SessionTimeoutModal({
  opened,
  remainingSeconds,
  onExtend,
  onLogout,
}: SessionTimeoutModalProps) {
  return (
    <Modal
      opened={opened}
      onClose={onExtend}
      title={
        <Group gap="xs">
          <IconAlertTriangle size={20} color="var(--mantine-color-orange-6)" />
          <Text fw={600}>Session Expiring</Text>
        </Group>
      }
      centered
      closeOnClickOutside={false}
      closeOnEscape={false}
      withCloseButton={false}
    >
      <Stack gap="md">
        <Text>
          Your session will expire in{" "}
          <Text span fw={700} c="orange">
            {formatTime(remainingSeconds)}
          </Text>{" "}
          due to inactivity. You will be logged out automatically for security.
        </Text>
        <Text size="sm" c="dimmed">
          Click &quot;Continue Session&quot; to stay logged in, or &quot;Log
          Out&quot; to end your session now.
        </Text>
        <Group justify="flex-end" mt="md">
          <Button variant="subtle" color="gray" onClick={onLogout}>
            Log Out
          </Button>
          <Button onClick={onExtend}>Continue Session</Button>
        </Group>
      </Stack>
    </Modal>
  );
}
